import Infographic from './Infographic';
import Filmstrip from './Filmstrip';
import Flourish from './Flourish';
import Fullscreen from './Fullscreen';

export default function SkinComponent({ skin, ...restProps }) {
    switch(skin) {
        case 'filmstrip':
            return <Filmstrip {...restProps} />;
        case 'flourish':
            return <Flourish {...restProps} />;
        case 'fullscreen':
            return <Fullscreen {...restProps} />;
        case 'infographic':
        default:
            return <Infographic {...restProps} />;
    }
}
